import { useLoaderData } from "react-router-dom";
import FlashCardManager from "../components/FlashCardManager";
import "../css/FlashCards.css";

export async function loader({ params }) {
  return null;
}

export async function action({ params }) {
  return null;
}

export default function TestAction() {
  const loaderData = useLoaderData();

  return (
    <div>
      <FlashCardManager></FlashCardManager>
    </div>
  );
}